module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/CD-ee36ed755d69a233fd0fb2f7d31cfcfc.svg";